import { Switch } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Switch',
    component: Switch,
});
